module.exports = __webpack_public_path__ + "img/search.30082f54.png";